import { Menu } from 'lucide-react'
import { useState } from 'react'

import { AgentSurface, PANEL_WIDTH } from './AgentSurface'
import { AgentTab } from './AgentTabBar'
import { Person } from './contacts'
import { ContactStrip } from './ContactStrip'
import { InviteSheet } from './InviteSheet'

/**
 * The same agent as its own native-feeling app rather than a panel inside the
 * web one. Muse's argument for this shape is push notifications — the agent
 * cannot start a conversation from a browser tab nobody has open.
 */
export function ReactAppMock({
  height,
  notified,
  connect,
  blankChat,
  initialTab,
  inviteOpen,
}: {
  height: number
  notified?: boolean
  /** Adds the Connect tab — the fleet assistant's fourth surface. */
  connect?: boolean
  /** Opens on nothing said yet, rather than mid-conversation. */
  blankChat?: boolean
  /** Opens on a surface other than the chat. */
  initialTab?: AgentTab
  /** Starts with the invite sheet already raised, for the screen that documents it. */
  inviteOpen?: boolean
}) {
  const [person, setPerson] = useState<Person | null>(null)
  const [inviting, setInviting] = useState(inviteOpen ?? false)

  return (
    <div
      style={{ width: PANEL_WIDTH, height }}
      className="border-ink-100 relative flex flex-col overflow-hidden rounded-xl border bg-white shadow-xl"
    >
      {/* The strip lays itself out across the full width — agent centred, people
          pinned right — so the menu is placed over it rather than beside it. */}
      <div className="relative">
        <span className="absolute top-2 left-3 z-10 flex h-11 items-center">
          <Menu className="text-ink-300 size-4 shrink-0" />
        </span>
        <ContactStrip person={person} onSelect={setPerson} unread={notified} />
      </div>
      <AgentSurface
        person={person}
        notified={notified}
        connect={connect}
        blankChat={blankChat}
        initialTab={initialTab}
        onInvite={() => setInviting(true)}
      />
      {inviting && <InviteSheet onClose={() => setInviting(false)} />}
    </div>
  )
}
